import _ from 'lodash'
import { getResults } from '../../search/api'
import { addEntityToStream } from '../api'
import { buildOrQuery, getSimpleLibraryFilter, addAdvancedSearchQueryStrings, originUuidCheck, addCatalogSearchCriteria, getUpdatedFacet } from '../../search/searchUtils'

export const loadSearchResults = ({ state, commit }, {data, resetFacets, facetNames, selectedFacetNames, currentFacets}) => {
  if (data.indexList.length === undefined || data.libraryList.length === undefined) {
    return {}
  }
  return getResults(data).then((res) => {
    let hits = (res && res.hits && res.hits.hits) ? res.hits.hits : []
    let total = (res && res.hits && res.hits.total && res.hits.total.value) ? res.hits.total.value : 0
    let processedHits = []
    for (var i = 0; i < hits.length; i++) {
      let result = {
        uuid: hits[i]._source.uuid,
        index: hits[i]._index,
        resourceType: hits[i]._index,
        type: hits[i]._source.type || hits[i]._type,
        title: hits[i]._source.title,
        description: hits[i]._source.description,
        num: hits[i]._source.num,
        crn: hits[i]._source.crn,
        meetingDaysRaw: hits[i]._source.meetingDaysRaw,
        currentSeats: hits[i]._source.currentSeats,
        maxSeats: hits[i]._source.maxSeats,
        creditHour: hits[i]._source.creditHour,
        roomInformation: hits[i]._source.roomInformation,
        specialInstructions: hits[i]._source.specialInstructions,
        block: hits[i]._source.block,
        gradeLevel: hits[i]._source.gradeLevel,
        academicTerm: hits[i]._source.academicTerm,
        creationTime: hits[i]._source.creationTime,
        lastUpdatedTime: hits[i]._source.lastUpdatedTime
      }
      processedHits.push(result)
    }

    const inputState = {
      resetAllFacets: resetFacets === true,
      selectedFacetNames: selectedFacetNames,
      currentFacets: currentFacets || {},
      responseFacets: res.aggregations || {}
    }

    let formattedFacets = {}
    if (facetNames && facetNames.length) {
      facetNames.forEach(facetName => {
        formattedFacets[facetName] = getUpdatedFacet(facetName, inputState)
      })
    }

    const response = {
      formattedFacets: formattedFacets,
      processedHits: processedHits,
      totalHits: total
    }
    return response
  })
}

export const executeSearchNoFacets = ({ state, commit }, {source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, facets, filter}) => {
  let filterObj = {
    'bool': originUuidCheck()
  }
  let filterCopy = (filter && filter.length) ? filter.slice() : []
  if (filterCopy.length > 0) {
    filterObj.bool['must'] = filterCopy
  }

  if (userId === undefined) {
    userId = localStorage.getItem('userid')
  }

  let sort = [{_score: {order: 'desc'}}]
  let libraryFilter = getSimpleLibraryFilter(publicLibraryList) // TODO use privateLibraryList?
  let buildQuery = {
    'constant_score': {
      'filter': buildOrQuery(libraryFilter),
      'boost': 1.0
    }
  }
  if (state.terms) {
    let queryString = {
      'query_string': {
        'query': 'TBA',
        'default_field': 'title'
      }
    }

    queryString.query_string.query = state.terms.split(',').join(' OR ')
    // buildQuery = buildOrQuery(libraryFilter)
    buildQuery.constant_score.filter.bool.must.push(queryString)
    // buildQuery.bool.must.push(queryString)
  }

  commit('UPDATE_PRIVATE_LIBRARY_LIST', privateLibraryList)
  commit('UPDATE_PUBLIC_LIBRARY_LIST', publicLibraryList)
  commit('UPDATE_QUERY', buildQuery)
  commit('UPDATE_SORT', sort)

  let payload = {
    sort: sort,
    _source: source,
    from: from,
    size: size,
    query: state.query,
    // aggs: facets,
    post_filter: filterObj
  }

  let requestPayload = {
    'indexList': indexList,
    'libraryList': libraryList,
    'payload': payload
  }

  const params = {
    data: requestPayload
  }
  return loadSearchResults({ state, commit }, params).then(response => {
    if (response) {
      commit('UPDATE_OTHER_RESULTS', response.processedHits || [])
      return response
    }
  })
}

export const executeAdvancedSearch = ({ state, commit }, {source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, pageNumber, facets, filter, facetNames, selectedFacetNames, resetFacets}) => {
  let filterObj = {
    'bool': originUuidCheck()
  }
  let filterCopy = (filter && filter.length) ? filter.slice() : []
  if (filterCopy.length > 0) {
    filterObj.bool['must'] = filterCopy
  }

  if (userId === undefined) {
    userId = localStorage.getItem('userid')
  }

  const sort = [{_score: {order: 'desc'}}]
  const libraryFilter = getSimpleLibraryFilter(publicLibraryList) // TODO use privateLibraryList?
  let buildQuery = {
    'constant_score': {
      'filter': buildOrQuery(libraryFilter),
      'boost': 1.0
    }
  }
  if (state.terms) {
    let queryString = {
      'query_string': {
        'query': 'TBA',
        'default_field': 'title'
      }
    }
    queryString.query_string.query = state.terms.split(',').join(' OR ')
    // buildQuery = buildOrQuery(libraryFilter)
    buildQuery.constant_score.filter.bool.must.push(queryString)
    // buildQuery.bool['filter'] = [filterObj]
  }

  addAdvancedSearchQueryStrings(state, buildQuery.constant_score.filter)

  commit('UPDATE_PRIVATE_LIBRARY_LIST', privateLibraryList)
  commit('UPDATE_PUBLIC_LIBRARY_LIST', publicLibraryList)
  commit('UPDATE_QUERY', buildQuery)
  commit('UPDATE_SORT', sort)

  let payload = {
    sort: sort,
    _source: source,
    from: from,
    size: size,
    query: state.query,
    aggs: facets,
    post_filter: filterObj
  }

  let requestPayload = {
    'indexList': indexList,
    'libraryList': libraryList,
    'payload': payload
  }

  const params = {
    data: requestPayload,
    resetFacets: resetFacets,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames,
    currentFacets: state.facets
  }
  return loadSearchResults({ state, commit }, params).then(response => {
    if (response) {
      commit('UPDATE_FACETS', response.formattedFacets || [])
      commit('UPDATE_RESULTS', response.processedHits || [])
      commit('UPDATE_TOTAL', response.totalHits || 0)
      return response
    }
  })
}

export const refreshAdvancedSearchResults = ({ state, commit }, {source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, pageNumber, facets, filter, facetNames, selectedFacetNames}) => {
  let resetFacets = true
  const params = {
    source: source,
    from: from,
    size: size,
    indexList: indexList,
    libraryList: libraryList,
    privateLibraryList: privateLibraryList,
    publicLibraryList: publicLibraryList,
    userId: userId,
    pageNumber: pageNumber,
    facets: facets,
    filter: filter,
    resetFacets: resetFacets,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames
  }
  return executeAdvancedSearch({ state, commit }, params)
}

export const refreshCatalogSearchResults = ({ state, commit }, {source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, pageNumber, facets, filter, facetNames, selectedFacetNames}) => {
  let resetFacets = true
  const params = {
    source: source,
    from: from,
    size: size,
    indexList: indexList,
    libraryList: libraryList,
    privateLibraryList: privateLibraryList,
    publicLibraryList: publicLibraryList,
    userId: userId,
    pageNumber: pageNumber,
    facets: facets,
    filter: filter,
    resetFacets: resetFacets,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames
  }
  return executeCatalogSearch({ state, commit }, params)
}

export const executeCatalogSearch = ({ state, commit }, {source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, pageNumber, facets, filter, facetNames, selectedFacetNames, resetFacets}) => {
  let filterObj = {
    'bool': originUuidCheck()
  }
  let filterCopy = (filter && filter.length) ? filter.slice() : []
  if (filterCopy.length > 0) {
    filterObj.bool['must'] = filterCopy
  }

  if (userId === undefined) {
    userId = localStorage.getItem('userid')
  }

  let buildQuery
  let sort
  const libraryFilter = getSimpleLibraryFilter(publicLibraryList) // TODO use privateLibraryList?
  if (state.terms) {
    let queryString = {
      'query_string': {
        'query': 'TBA',
        'default_field': 'title'
      }
    }

    queryString.query_string.query = state.terms.split(',').join(' ')

    buildQuery = buildOrQuery(libraryFilter)
    buildQuery.bool.must.push(queryString)

    addCatalogSearchCriteria(state, buildQuery)

    sort = [{_score: {order: 'desc'}}]
  } else {
    buildQuery = {
      'constant_score': {
        'filter': buildOrQuery(libraryFilter),
        'boost': 1.0
      }
    }

    addCatalogSearchCriteria(state, buildQuery.constant_score.filter)
    sort = [{_id: {order: 'asc'}}]
  }

  commit('UPDATE_QUERY', buildQuery)
  commit('UPDATE_SORT', sort)

  let payload = {
    sort: sort,
    _source: source,
    from: from,
    size: size,
    query: state.query,
    aggs: facets,
    post_filter: filterObj
  }

  let requestPayload = {
    'indexList': indexList,
    'libraryList': libraryList,
    'payload': payload
  }

  const params = {
    data: requestPayload,
    resetFacets: resetFacets,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames,
    currentFacets: state.catalogFacets
  }
  return loadSearchResults({ state, commit }, params).then(response => {
    if (response) {
      commit('UPDATE_CATALOG_FACETS', response.formattedFacets || [])
      commit('UPDATE_CATALOG_RESULTS', response.processedHits || [])
      commit('UPDATE_CATALOG_TOTAL', response.totalHits || 0)
      return response
    }
  })
}

export const updateCourseSearchState = ({ state, commit }, {courseSearchData}) => {
  commit('UPDATE_TERMS', courseSearchData.keywords)
  commit('UPDATE_DEPARTMENT', courseSearchData.department)
  commit('UPDATE_SUBJECT', courseSearchData.subject)
  commit('UPDATE_SEMESTER', courseSearchData.semester)
  commit('UPDATE_SELECTED_SEMESTERS', courseSearchData.selectedSemesters)
  commit('UPDATE_DIVISION', courseSearchData.division)
  commit('UPDATE_INSTRUCTOR', courseSearchData.instructor)
  commit('UPDATE_MAJOR', courseSearchData.major)
  commit('UPDATE_UNIT', courseSearchData.unit)
  commit('UPDATE_TERM_CODE', courseSearchData.termCode)
  commit('UPDATE_PLANNING_TERM', courseSearchData.termCode)
  commit('UPDATE_QR', courseSearchData.qr)
  commit('UPDATE_FIRSTYEAR', courseSearchData.firstyear)
  commit('UPDATE_MONDAY', courseSearchData.monday)
  commit('UPDATE_TUESDAY', courseSearchData.tuesday)
  commit('UPDATE_WEDNESDAY', courseSearchData.wednesday)
  commit('UPDATE_THURSDAY', courseSearchData.thursday)
  commit('UPDATE_FRIDAY', courseSearchData.friday)
  commit('UPDATE_CLASS_TIME_FROM', courseSearchData.classTimeFrom)
  commit('UPDATE_CLASS_TIME_TO', courseSearchData.classTimeTo)
  commit('UPDATE_COURSE_FLAGS', courseSearchData.courseFlags)
  commit('UPDATE_COURSE_BLOCK', courseSearchData.block)
  commit('UPDATE_COURSE_LEVEL', courseSearchData.level)
  commit('UPDATE_COURSE_YEAR', courseSearchData.academicYear)
  commit('UPDATE_PAGE_NUMBER', 1)
  commit('UPDATE_FROM', 0)
  commit('UPDATE_SIZE', 50)
  commit('UPDATE_TIMESTAMP', courseSearchData.lastUpdatedTime)
  commit('UPDATE_CATALOG_TIMESTAMP', courseSearchData.catalogSearchTimeStamp)
}

export const updateSearchAcademicYear = ({ state, commit }, {academicYear}) => {
  commit('UPDATE_COURSE_YEAR', academicYear)
}

export const updateSemesterMap = ({ state, commit }, {semesterMap}) => {
  commit('UPDATE_SEMESTER_MAP', semesterMap)
  commit('UPDATE_SEMESTER_CODE_MAP', _.invert(semesterMap))
}

export const resetCourseSearchFacets = ({ state, commit }) => {
  let formattedFacets = {
    'facetedCourseTags': [],
    'catalogCourseDepartment': [],
    'catalogCourseSubject': [],
    'catalogCourseDivision': [],
    'catalogCourseInstructor': [],
    'catalogCourseCredit': [],
    'catalogCourseTime': [],
    'catalogCourseFlag': [],
    'catalogCourseBlock': [],
    'catalogCourseGradeLevel': [],
    'catalogCourseYear': [],
    'catalogCourseTerm': []
  }
  commit('UPDATE_FACETS', formattedFacets)
}

export const updateFrom = ({ state, commit }, from) => {
  commit('UPDATE_FROM', from)
}

export const updateSelectedStream = ({ state, commit }, {streamUuid}) => {
  commit('UPDATE_SELECTED_STREAM', streamUuid)
}

export const updatePageNumber = ({ state, commit }, pageNumber) => {
  commit('UPDATE_PAGE_NUMBER', pageNumber)
}

export const updateSize = ({ state, commit }, size) => {
  commit('UPDATE_SIZE', size)
}

export const setFacetSelected = ({ state, commit }, {facet, isSelected, facetName}) => {
  commit('UPDATE_SINGLE_FACET', {facet, isSelected, facetName})
}

export const addToMyStream = ({ state, commit }, {streamUuid, courseData, data, currentSemester, currentYear, termCode, entityType, userRole}) => {
  let streamId = streamUuid || state.selectedStreamUuid
  if ((!currentSemester || !currentYear) && state.semester) {
    currentSemester = state.semester.split(' ')[0]
    currentYear = state.semester.split(' ')[1]
  }
  // show the most recent semester on the AddToStream component
  commit('UPDATE_PLANNING_TERM', termCode)
  commit('UPDATE_SEMESTER', currentSemester + ' ' + currentYear)
  const sendMessageToChannel = userRole === 'Advisor'
  const objectToAdd = courseData && courseData.uuid ? courseData : data
  return addEntityToStream(streamId, objectToAdd, currentYear, currentSemester, termCode, entityType, sendMessageToChannel).then(response => {
    return response
  })
}

export const toggleCatalogSearchDropDown = ({ state, commit }) => {
  commit('TOGGLE_CATALOG_DROP_DOWN')
}

export const showCatalogSearchDropDown = ({ state, commit }) => {
  commit('SHOW_CATALOG_DROP_DOWN')
}

export const hideCatalogSearchDropDown = ({ state, commit }) => {
  commit('HIDE_CATALOG_DROP_DOWN')
}

export const updateCourseSearchFlags = ({ state, commit }, flagMap) => {
  commit('UPDATE_COURSE_SEARCH_FLAGS', flagMap)
}



// WEBPACK FOOTER //
// ./src/app/advancedSearch/vuex/actions.js